export default "__VITE_ASSET__BZXHQRV___"